module.exports = __webpack_public_path__ + "static/media/matilde-cap-sri-lanka-happy.97574326.png";